/* assets/custom-infinite-slider.js */
const initSwiper = () => {
  if (typeof Swiper === 'undefined') {
    setTimeout(initSwiper, 100);
    return;
  }
  const sliders = document.querySelectorAll('.swiper-custom-infinite:not(.swiper-initialized)');
  
  sliders.forEach(function(sliderElement) {
    const mobileColumns = parseInt(sliderElement.dataset.mobileColumns) || 2;
    const desktopColumns = parseInt(sliderElement.dataset.desktopColumns) || 4;
    const parent = sliderElement.parentElement;
    
    new Swiper(sliderElement, {
      slidesPerView: mobileColumns,
      spaceBetween: 16,
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: parent.querySelector('.swiper-custom-infinite-next'),
        prevEl: parent.querySelector('.swiper-custom-infinite-prev'),
      },
      pagination: {
        el: parent.querySelector('.swiper-custom-infinite-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: Math.max(2, desktopColumns - 1),
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: desktopColumns,
          spaceBetween: 24,
        }
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', initSwiper);
document.addEventListener('shopify:section:load', initSwiper);
